import { createMuiTheme } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";

export default createMuiTheme({
  palette: {
    primary: {
      main: "#0085BA",
    },
    secondary: {
      main: "#23282D",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
});
